import { HomeConfig } from '@tenants/types/tenant';
import { LOCALE_HOME_PATHS, LOCALE_INTERNAL_LINKS_PATHS } from 'types/locales';

export function createHomeConfig(): HomeConfig {
  const homeConfig: HomeConfig = {
    heroVideo: '/ca-hero-1.mp4',
    joinLink: 'https://join.exprealty.ca',
    internalLinks: [
      {
        title: LOCALE_INTERNAL_LINKS_PATHS.PROVINCES_TERRITORIES,
        links: [
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.ALBERTA,
            link: '/alberta-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.BRITISH_COLUMBIA,
            link: '/british-columbia-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.MANITOBA,
            link: '/manitoba-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.NEW_BRUNSWICK,
            link: '/new-brunswick-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.NEWFOUNDLAND_LABRADOR,
            link: '/newfoundland-and-labrador-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.NOVA_SCOTIA,
            link: '/nova-scotia-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.ONTARIO,
            link: '/ontario-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.QUEBEC,
            link: '/quebec-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.SASKATCHEWAN,
            link: '/saskatchewan-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.YUKON,
            link: '/yukon-real-estate',
          },
        ],
      },
      {
        title: LOCALE_INTERNAL_LINKS_PATHS.METRO_AREAS,
        links: [
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.TORONTO,
            link: '/toronto-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.VANCOUVER,
            link: '/vancouver-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.CALGARY,
            link: '/calgary-ab-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.EDMONTON,
            link: '/edmonton-ab-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.OTTAWA,
            link: '/ottawa-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.HAMILTON,
            link: '/hamilton-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.LONDON,
            link: '/london-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.HALIFAX,
            link: '/halifax-ns-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.ST_CATHARINES,
            link: 'st-catharines-on-real-estate',
          },
        ],
      },
      {
        title: LOCALE_INTERNAL_LINKS_PATHS.POPULAR_ONTARIO_CITIES,
        links: [
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.BARRIE_HOMES_FOR_SALE,
            link: '/barrie-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.BRADFORD_WEST_HOMES_FOR_SALE,
            link: '/bradford-west-gwillimbury-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.CAMBRIDGE_HOMES_FOR_SALE,
            link: '/cambridge-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.COLLINGWOOD_HOMES_FOR_SALE,
            link: '/collingwood-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.GUELPH_HOMES_FOR_SALE,
            link: '/guelph-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.HAMILTON_HOMES_FOR_SALE,
            link: '/hamilton-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.KITCHENER_HOMES_FOR_SALE,
            link: '/kitchener-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.LONDON_HOMES_FOR_SALE,
            link: '/london-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.ORILLIA_HOMES_FOR_SALE,
            link: '/orillia-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.OTTAWA_HOMES_FOR_SALE,
            link: '/ottawa-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.PETERBOROUGH_HOMES_FOR_SALE,
            link: '/peterborough-on-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.WATERLOO_HOMES_FOR_SALE,
            link: '/waterloo-on-real-estate',
          },
        ],
      },
      {
        title: LOCALE_INTERNAL_LINKS_PATHS.POPULAR_WESTERN_CANADA_CITIES,
        links: [
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.VANCOUVER_HOMES_FOR_SALE,
            link: '/vancouver-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.BURNABY_HOMES_FOR_SALE,
            link: '/burnaby-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.COQUITLAM_HOMES_FOR_SALE,
            link: '/coquitlam-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.MAPLE_RIDGE_HOMES_FOR_SALE,
            link: '/maple-ridge-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.NEW_WESTMINSTER_HOMES_FOR_SALE,
            link: '/new-westminster-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.NORTH_VANCOUVER_HOMES_FOR_SALE,
            link: '/north-vancouver-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.RICHMOND_HOMES_FOR_SALE,
            link: '/richmond-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.SURREY_HOMES_FOR_SALE,
            link: '/surrey-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.VICTORIA_HOMES_FOR_SALE,
            link: '/victoria-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.WHITE_ROCK_HOMES_FOR_SALE,
            link: '/white-rock-bc-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.CALGARY_HOMES_FOR_SALE,
            link: '/calgary-ab-real-estate',
          },
          {
            label: LOCALE_INTERNAL_LINKS_PATHS.EDMONTON_HOMES_FOR_SALE,
            link: '/edmonton-ab-real-estate',
          },
        ],
      },
    ],
    contentCards: {
      sectionTitleParts: [
        LOCALE_HOME_PATHS.CONTENT_CARDS_SECTION_TITLE_PARTS_FIRST,
        LOCALE_HOME_PATHS.CONTENT_CARDS_SECTION_TITLE_PARTS_SECOND,
        LOCALE_HOME_PATHS.CONTENT_CARDS_SECTION_TITLE_PARTS_THIRD,
      ],
      cards: [
        {
          title: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_BUY_WITH_US_TITLE,
          image: '/next/assets/images/content-cards/buy.jpg',
          titleColor: 'rgba(255, 255, 255, 0.7)',
          backgroundColor: '#163259',
          content: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_BUY_WITH_US_CONTENT,
          link: '/buy',
          desktopTransform: 'rotate(-5deg)',
          tabletTransform: 'none',
        },
        {
          title: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_SELL_WITH_US_TITLE,
          image: '/next/assets/images/content-cards/sell.jpg',
          titleColor: 'rgba(255, 255, 255, 0.7)',
          backgroundColor: '#6C82A0',
          content: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_SELL_WITH_US_CONTENT,
          link: '/sell',
          tabletTransform: 'translateY(3em)',
          translateYTablet: '50',
        },
        {
          title: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_FIND_AN_AGENT_TITLE,
          image: '/next/assets/images/content-cards/agent.jpg',
          titleColor: '#163259',
          backgroundColor: '#DAE0E7',
          content: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_FIND_AN_AGENT_CONTENT,
          link: '/agents-search',
          desktopTransform: 'rotate(2deg) translateY(-1.5em)',
          tabletTransform: 'none',
          translateYDesktop: '-20',
        },
        {
          title: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_SOLD_NEARBY_TITLE,
          image: '/next/assets/images/content-cards/sold.jpg',
          titleColor: '#6D6F7C',
          backgroundColor: '#EEEEEE',
          content: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_SOLD_NEARBY_CONTENT,
          link: '/real-estate/sold',
          desktopTransform: 'rotate(7deg) translateY(2em)',
          tabletTransform: 'translateY(3em)',
          translateYDesktop: '40',
          translateYTablet: '50',
          hasDynamicLink: true,
        },
      ],
    },
  };
  return homeConfig;
}